'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Logger class.
 *
 * @class
 *
 * @license https://opensource.org/licenses/MIT
 *
 * @author Patrick Heng & Fabien Motte <hengpatrick.pro@gmail.com / contact@fabienmotte.com>
 *
 * @example
 * const logger = new Logger()
 * logger.log('Test')
 */
var Logger = function () {
  /**
   * Creates an instance of Logger.
   *
   * @constructor
   */
  function Logger() {
    _classCallCheck(this, Logger);

    /**
     * @name enabled
     * @type Boolean
     * @private
     */
    this._enabled = true;

    /**
     * @type Object
     * @private
     */
    this._defaultsLevels = { log: {}, info: {}, warn: {}, error: {}

      /**
       * @type Object
       * @private
       */
    };this._levels = { log: {}, info: {}, warn: {}, error: {}

      /**
       * @type Array
       * @private
       */
    };this._commands = ['group', 'time'];

    /**
     * @type Object
     * @private
     */
    this._plugins = {};

    /**
     * @type Function|null
     * @private
     */
    this._logHandler = null;

    this._bindLevels();
    this._bindCommands();
  }

  /**
   * Enable logging.
   *
   * @returns {Logger} `this`
   */


  _createClass(Logger, [{
    key: 'on',
    value: function on() {
      this._enabled = true;
      return this;
    }

    /**
     * Disable logging.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: 'off',
    value: function off() {
      this._enabled = false;
      return this;
    }

    /**
     * Reset levels and plugins.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this._levels = { log: {}, info: {}, warn: {}, error: {} };
      this._plugins = {};
      this._bindLevels();
    }

    /**
     * Line break.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: 'br',
    value: function br() {
      this._print('log', {}, '');
      return this;
    }

    /**
     * Add/modify a level.
     *
     * @param {String} name Level name.
     * @param {Object} [options={}] Level options.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: 'level',
    value: function level(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof name !== 'string') {
        return this._printError('Logger.level() : \'name\' argument is required');
      }

      if (typeof this._levels[name] !== 'undefined') {
        // Modify existing level options
        this._levels[name] = _extends({}, this._levels[name], options);
      } else {
        // Add a new level
        this._levels[name] = options;
      }
      this._bindLevel(name, options);

      return this;
    }

    /**
     * Add/modify a plugin.
     *
     * @param {String} name Plugin name.
     * @param {Function|Object} fn Plugin callback function/plugin options if plugin already exists.
     * @param {Object} [options={}] Plugin options.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: 'plugin',
    value: function plugin(name, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof name !== 'string') {
        return this._printError('Logger.plugin() : \'name\' argument is required');
      }

      if (typeof this._plugins[name] !== 'undefined' && (typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object' && fn !== null) {
        // Modify existing plugin options
        this._plugins[name].options = _extends({}, this._plugins[name].options, fn);
        return this;
      } else if (typeof fn !== 'function') {
        return this._printError('Logger.plugin() : \'fn\' argument must be a function');
      }

      this._plugins[name] = {
        fn: fn.bind(this),
        options: _extends({
          enabled: true
        }, options)
      };

      return this;
    }

    /**
     * Set log handler.
     *
     * @param {Function} handlerFn Handler function.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: 'setHandler',
    value: function setHandler(handlerFn) {
      this._logHandler = handlerFn;

      return this;
    }

    /**
     * Bind levels.
     * @private
     */

  }, {
    key: '_bindLevels',
    value: function _bindLevels() {
      for (var levelName in this._levels) {
        var levelOptions = this._levels[levelName];
        this._bindLevel(levelName, levelOptions);
      }
    }

    /**
     * Bind a level.
     * @private
     *
     * @param {String} levelName Level name.
     * @param {Object} levelOptions Level options.
     */

  }, {
    key: '_bindLevel',
    value: function _bindLevel(levelName, levelOptions) {
      var _this = this;

      this[levelName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this._levelCallback(levelName, levelOptions, args);
      };
    }

    /**
     * Level callback.
     * @private
     *
     * @param {String} levelName Level name.
     * @param {Object} levelOptions Level options.
     * @param {Array} args Level arguments.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: '_levelCallback',
    value: function _levelCallback(levelName, levelOptions, args) {
      if (!this._enabled) {
        return;
      }

      var msgs = args;

      if (this._logHandler !== null) {
        this._logHandler(msgs);
      }

      var _applyPlugins2 = this._applyPlugins(levelName, levelOptions, msgs),
          pMsgs = _applyPlugins2.msgs,
          before = _applyPlugins2.before,
          after = _applyPlugins2.after,
          pStyles = _applyPlugins2.styles;

      return this._print(levelName, levelOptions, pMsgs, before, after, pStyles);
    }

    /**
     * Bind commands.
     * @private
     */

  }, {
    key: '_bindCommands',
    value: function _bindCommands() {
      var _this2 = this;

      var _loop = function _loop(i, l) {
        var command = _this2._commands[i];

        _this2[command] = function (name) {
          return console[command](name);
        };
        _this2[command + 'End'] = function (name) {
          return console[command + 'End'](name);
        };
      };

      for (var i = 0, l = this._commands.length; i < l; i++) {
        _loop(i, l);
      }
    }

    /**
     * Apply registered plugins.
     * @private
     *
     * @param {String} levelName Level name.
     * @param {Object} levelOptions Level options.
     * @param {Array} msgs Messages.
     *
     * @returns {Object} Message, middlewares and styles.
     */

  }, {
    key: '_applyPlugins',
    value: function _applyPlugins(levelName, levelOptions, msgs) {
      var styles = [];
      var before = [];
      var after = [];

      for (var pluginName in this._plugins) {
        var plugin = this._plugins[pluginName];
        var level = { name: levelName, options: levelOptions };

        if (!plugin.options.enabled) {
          continue;
        }

        var _plugin$fn = plugin.fn(msgs, plugin.options, level),
            pMsgs = _plugin$fn.msgs,
            pBefore = _plugin$fn.before,
            pAfter = _plugin$fn.after,
            pStyles = _plugin$fn.styles;

        if (pMsgs) {
          msgs = pMsgs;
        }

        if (pBefore) {
          before = before.concat('<styles>' + pBefore + '</styles>');
        }

        if (pAfter) {
          after = after.concat(pAfter);
        }

        styles = styles.concat(pStyles || {});
      }

      return { msgs: msgs, before: before, after: after, styles: styles };
    }

    /**
     * Print a message.
     * @private
     *
     * @param {strin} levelName Level name.
     * @param {Object} [levelOptions={}] Level options.
     * @param {Array} [msgs=[]] Messages.
     * @param {Array} [before=[]] Before middleware.
     * @param {Array} [after=[]] After middleware.
     * @param {Array} [pluginsStyles={}] Plugins styles.
     *
     * @returns {Logger} `this`
     */

  }, {
    key: '_print',
    value: function _print(levelName) {
      var levelOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var msgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var before = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var after = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var pluginsStyles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      var finalMsgs = [];
      var globalStyles = [];

      if (levelOptions.styles) {
        // Merge current level and plugins styles
        pluginsStyles = this._mergeStyles(levelOptions.styles, pluginsStyles);
      }

      // Merge plugins styles and concat to global styles
      pluginsStyles = this._parsePluginsStyles(pluginsStyles);
      globalStyles = globalStyles.concat(pluginsStyles);

      // Apply level styles
      if (levelOptions.styles) {
        globalStyles.push(this._parseStyles(levelOptions.styles));
        globalStyles.push('');
      }

      // Before message
      if (before.length) {
        finalMsgs.push(this._parseMsgTags(before).join(' '));
      }

      // Sort messages (string and others types)

      var _sortMsgs2 = this._sortMsgs(msgs),
          stringMsgs = _sortMsgs2.stringMsgs,
          othersMsgs = _sortMsgs2.othersMsgs;

      if (levelOptions.styles) {
        stringMsgs[0] = '<styles>' + stringMsgs[0];
        stringMsgs[stringMsgs.length - 1] += '</styles>';
      }

      // Messages
      finalMsgs.push(this._parseMsgTags(stringMsgs).join(' '));

      // After message
      if (after.length) {
        finalMsgs.push(this._parseMsgTags(after).join(' '));
      }

      finalMsgs = finalMsgs.join(' ');

      if (!(0, _utils.isBrowser)()) {
        finalMsgs = finalMsgs.replace(/%c/g, '');
      }

      // Arguments
      var args = [finalMsgs];

      if ((0, _utils.isBrowser)()) {
        args.push.apply(args, _toConsumableArray(globalStyles).concat(_toConsumableArray(othersMsgs)));
      } else {
        args.push.apply(args, _toConsumableArray(othersMsgs));
      }

      // Check console
      if (typeof console === 'undefined') {
        return this;
      }

      if (typeof this._defaultsLevels[levelName] !== 'undefined') {
        // Native level
        console[levelName].apply(console, args);
      } else {
        // Custom level, fallback to console.log()
        console.log.apply(console, args);
      }

      if (levelName === 'error' || levelName === 'warn') {
        return false;
      }

      return true;
    }

    /**
     * Merge level and plugins styles.
     * @private
     *
     * @param {Object} levelStyles Level styles.
     * @param {Array} pluginsStyles Plugins styles.
     *
     * @returns {Object} Merged styles.
     */

  }, {
    key: '_mergeStyles',
    value: function _mergeStyles(levelStyles, pluginsStyles) {
      var mergedPluginsStyles = [];

      for (var i = 0, l = pluginsStyles.length; i < l; i++) {
        var pluginStyles = pluginsStyles[i];
        mergedPluginsStyles.push(_extends({}, pluginStyles, levelStyles));
      }

      return mergedPluginsStyles;
    }

    /**
     * Parse styles to CSS.
     * @private
     *
     * @param {Object} styles Styles.
     *
     * @returns {String} Parsed styles.
     */

  }, {
    key: '_parseStyles',
    value: function _parseStyles(styles) {
      var parsedStyles = '';

      for (var property in styles) {
        var value = styles[property];
        parsedStyles += (0, _utils.camelToKebab)(property) + ': ' + value + ';';
      }

      return parsedStyles;
    }

    /**
     * Parse plugins styles.
     * @private
     *
     * @param {Array} pluginsStyles Plugins styles.
     *
     * @returns {Array} Parsed plugins styles.
     */

  }, {
    key: '_parsePluginsStyles',
    value: function _parsePluginsStyles(pluginsStyles) {
      var parsedStyles = [];

      for (var i = 0, l = pluginsStyles.length; i < l; i++) {
        var styles = pluginsStyles[i];
        parsedStyles.push(this._parseStyles(styles));
        parsedStyles.push(''); // Reset styles
      }

      return parsedStyles;
    }

    /**
     * Parse messages tags.
     * @private
     *
     * @param {Array} msgs Messages.
     *
     * @returns {Array} Parsed messages.
     */

  }, {
    key: '_parseMsgTags',
    value: function _parseMsgTags(msgs) {
      for (var i = 0, l = msgs.length; i < l; i++) {
        if (typeof msgs[i] === 'string') {
          msgs[i] = msgs[i].replace(/<(\/)?styles>/gi, '%c');
        }
      }

      return msgs;
    }

    /**
     * Sort messages.
     * @private
     *
     * @param {Array} msgs Messages.
     *
     * @returns {Object} Sorted messages.
     */

  }, {
    key: '_sortMsgs',
    value: function _sortMsgs(msgs) {
      var stringMsgs = [];
      var othersMsgs = [];

      for (var i = 0, l = msgs.length; i < l; i++) {
        var msg = msgs[i];
        if (typeof msg === 'string') {
          stringMsgs.push(msg);
        } else {
          othersMsgs.push(msg);
        }
      }

      return { stringMsgs: stringMsgs, othersMsgs: othersMsgs };
    }

    /**
     * Print self error message.
     * @private
     *
     * @param {String} msg Message.
     */

  }, {
    key: '_printError',
    value: function _printError(msg) {
      this.reset();
      this.error(msg);
    }
  }]);

  return Logger;
}();

exports.default = Logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-log/lib/Logger.js
// module id = 245
// module chunks = 1